import { clamp } from './helpers'

export const clamp01 = (value) => clamp(Number(value) || 0, 0, 1)

export const boostBlinkForLid = (value) => {
  const raw = clamp01(value)
  const withoutDeadzone = clamp01((raw - 0.12) / 0.88)
  const boosted = raw * 0.7 + Math.pow(withoutDeadzone, 0.62) * 0.9
  return clamp01(boosted)
}

export const resolveLidThresholds = (settings = {}) => {
  const startRaw = Number(settings?.lidCloseStart)
  const fullRaw = Number(settings?.lidCloseFull)
  const startBase = Number.isFinite(startRaw) ? clamp01(startRaw) : 0.5
  const fullBase = Number.isFinite(fullRaw) ? clamp01(fullRaw) : 0.85

  // Keep user values when stricter, but cap to responsive defaults for winks.
  const start = Math.min(startBase, 0.28)
  const full = Math.max(start + 0.02, Math.min(fullBase, 0.64))
  return { start, full }
}

export const blinkToPhase = (blink, start, full) =>
  clamp01((clamp01(blink) - start) / Math.max(1e-4, full - start))

export const resolveEyeBlinkState = ({
  blinkLeft = 0,
  blinkRight = 0,
  blinkPhaseL = 0,
  blinkPhaseR = 0,
  settings = {}
} = {}) => {
  const rawBlinkLeft = clamp01(blinkLeft)
  const rawBlinkRight = clamp01(blinkRight)
  const inputPhaseLeft = clamp01(blinkPhaseL)
  const inputPhaseRight = clamp01(blinkPhaseR)
  const { start, full } = resolveLidThresholds(settings)

  const eyelidBlinkLeft = Math.max(boostBlinkForLid(rawBlinkLeft), inputPhaseLeft)
  const eyelidBlinkRight = Math.max(boostBlinkForLid(rawBlinkRight), inputPhaseRight)
  const lidPhaseLeft = blinkToPhase(eyelidBlinkLeft, start, full)
  const lidPhaseRight = blinkToPhase(eyelidBlinkRight, start, full)

  // Keep eye fade and lid motion aligned without over-closing in neutral frames.
  const eyeRenderBlinkLeft = clamp01(Math.max(inputPhaseLeft, eyelidBlinkLeft))
  const eyeRenderBlinkRight = clamp01(Math.max(inputPhaseRight, eyelidBlinkRight))

  return {
    rawBlinkLeft,
    rawBlinkRight,
    lidStart: start,
    lidFull: full,
    eyelidBlinkLeft,
    eyelidBlinkRight,
    lidPhaseLeft,
    lidPhaseRight,
    eyeRenderBlinkLeft,
    eyeRenderBlinkRight
  }
}

export default {
  clamp01,
  boostBlinkForLid,
  resolveLidThresholds,
  blinkToPhase,
  resolveEyeBlinkState
}
